export const ordenarPlatosDeMenu = (menu) => {
    const platos = Array.isArray(menu?.platos) ? [...menu.platos] : [];

    // 1) Orden por platoIds
    if (Array.isArray(menu?.platoIds) && menu.platoIds.length && platos.length) {
        const pos = new Map(menu.platoIds.map((id, i) => [Number(id), i]));
        platos.sort((a, b) => {
            const ia = pos.get(Number(a?.id));
            const ib = pos.get(Number(b?.id));
            if (ia == null && ib == null) return 0;
            if (ia == null) return 1;
            if (ib == null) return -1;
            return ia - ib;
        });
        return platos;
    }

    // 2) Fallback: campo 'orden'
    if (platos.length && platos.every((p) => p?.orden != null)) {
        platos.sort((a, b) => a.orden - b.orden);
        return platos;
    }

    return platos;
};

export const normalizarEventosConMenus = (evs) =>
    (Array.isArray(evs) ? evs : []).map((evento) => ({
        ...evento,
        menus: (evento?.menus || []).map((m) => ({
            ...m,
            platos: ordenarPlatosDeMenu(m),
        })),
    }));
